import {
  jb_info_block_css_default
} from "./chunk.ZTJOYEJE.js";
import {
  ae
} from "./chunk.RIMVGMXQ.js";
import {
  Spaceable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.LK5OUX7S.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ChangesBackgroundColor
} from "./chunk.6ORGI2J5.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-info-block/jb-info-block.ts
var JbInfoBlock = class extends ChangesBackgroundColor(Spaceable(r)) {
  _getContentSpacingProperties() {
    return { align: "center", colsMdUp: 10 };
  }
  _tracking(e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "info-block"
    });
    if (jbTrackingEvent) this.dispatchEvent(jbTrackingEvent);
  }
  render() {
    return ke`
      <article
        class=${Rt({
      "alternative-layout": !!this.isAlternativeLayout
    })}
      >
        <div class="wrap">
          ${this.context ? ke`<h5 class="context">${this.context}</h5>` : D}
          <h3 class="title">${this.headline}</h3>
          <jb-richtext @jb-link:clicked=${this._tracking}>${ae(this.text)}</jb-richtext>
          ${this.button ? ke`<jb-button-secondary
                .link=${this.button?.link}
                .text=${this.button?.text}
                @jb-link:clicked=${this._tracking}
              ></jb-button-secondary>` : D}
        </div>
      </article>
    `;
  }
};
JbInfoBlock.styles = jb_info_block_css_default;
__decorateClass([
  n({ type: Object })
], JbInfoBlock.prototype, "button", 2);
__decorateClass([
  n()
], JbInfoBlock.prototype, "context", 2);
__decorateClass([
  n()
], JbInfoBlock.prototype, "headline", 2);
__decorateClass([
  n({ type: Boolean })
], JbInfoBlock.prototype, "isAlternativeLayout", 2);
__decorateClass([
  n()
], JbInfoBlock.prototype, "text", 2);
JbInfoBlock = __decorateClass([
  customElement("jb-info-block")
], JbInfoBlock);

export {
  JbInfoBlock
};
